import React from 'react';
import delpicklogo from "../assests/images/delpicklogo.png";

import loader from "../assests/images/loader.gif";



const Loader = () => {
    return (
        <>
            <div className='adm_loader'>
                <div className='adm_loaderin'>
                    <img src={loader} alt='delpicklogo' className='adm_loadlogo' />
                    <div className='mt-3 mt-sm-4'>
                        <img src={delpicklogo} alt='delpicklogo' className='adm_loadlogotwo' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Loader;